import useAssetExtrasQuery from './useAssetExtrasQuery';
import useAssetRatingQuery from './useAssetRatingQuery';
import useAssetUpdateRatingQuery from './useAssetUpdateRatingQuery';

export { useAssetExtrasQuery, useAssetRatingQuery, useAssetUpdateRatingQuery };
